/**
 * useRadius — returns the canonical corner-radius scale.
 *
 * Radius is theme-invariant, so this simply returns the RADIUS constant.
 * The hook exists for a consistent API alongside useThemeColors/useSpacing/etc.
 *
 * @example
 * const radius = useRadius();
 * <View style={{ borderRadius: radius.lg }} />
 */
import { RADIUS } from '@/constants/shared/theme/radius';
import type { Radius } from '@/constants/shared/theme';

export function useRadius(): Radius {
  return RADIUS;
}
